export const isDefined = <T>(arg: T | undefined): arg is T => arg !== undefined;

export const isDefinedAndNotNull = <T>(arg: T | undefined | null): arg is T => arg !== undefined && arg !== null;
